<template>
  <div class="filter">
    <a
      v-for="(item, key) of this.tabs"
      :key="key"
      @click="toggleFilter(key)"
      :class="{ checked: checkedFilter == key }"
      >{{ item }}</a
    >
  </div>
</template>

<script>
export default {
  name: "TabSelect",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    defaultFilter: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      checkedFilter: 0,
    };
  },
  created() {
    this.toggleFilter(this.defaultFilter);
  },
  methods: {
    toggleFilter(to) {
      this.checkedFilter = to;
      this.$emit("change", to);
    },
  },
};
</script>

<style scoped>
.filter {
  align-self: center;
  display: flex;
  border-radius: 15px;
  overflow: hidden;
}

.filter a {
  padding: 15px 20px;
  background: #f3f3f3;
  color: var(--borders);
  cursor: pointer;
}

.filter a:hover {
  filter: brightness(0.95);
}

.checked {
  background: var(--secondary-fg) !important;
  color: #fff !important;
}

.uncheckfilter {
  padding: 15px;
  background: #ffffff;
  min-width: max-content;
  border-radius: 25px;
}

.uncheckfilter > * {
  padding: 5px;
}

.dateselect {
  position: relative;
  display: flex;
  gap: 25px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: fit-content;
}

.fadeouttext {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 45%,
    rgba(255, 255, 255, 0) 55%,
    rgba(255, 255, 255, 1) 100%
  );
}

.dateselect ul {
  list-style: none;
  display: flex;
  align-content: center;
  align-items: center;
  gap: 25px;
  margin: 0;
  padding: 0;
}

.dateselect .available .active {
  font-weight: 700;
  text-decoration: underline;
}

.dateselect .available li:hover {
  text-decoration: underline;
  cursor: pointer;
}

.leftmonths {
  color: #d4d4d4;
  cursor: vertical-text;
}
</style>
